import { useMutation } from "@tanstack/react-query";
import $api from "@/zapi-frontend/shared/api/axios";

type ChangePasswordPayload = {
  currentPassword: string;
  newPassword: string;
};

export function useChangePassword() {
  return useMutation({
    mutationFn: async (data: ChangePasswordPayload) => {
      return await $api.post("/auth/passwords/change", data);
    }
  });
}
